import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import HomePage from "./pages/HomePage";
import BasementsPage from "./pages/BasementsPage";
import BathroomsPage from "./pages/BathroomsPage";
import CustomFeaturesPage from "./pages/CustomFeaturesPage";
import GalleryPage from "./pages/GalleryPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PricingPage from "./pages/PricingPage";
import FloatingCTA from "./components/FloatingCTA";

// Google Analytics tracking (ready for GA ID)
const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

function App() {
  useEffect(() => {
    // Initialize Google Analytics when ID is provided
    if (GA_TRACKING_ID) {
      // Load GA script
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
      script.async = true;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', GA_TRACKING_ID);
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/basements" element={<BasementsPage />} />
          <Route path="/bathrooms" element={<BathroomsPage />} />
          <Route path="/custom-features" element={<CustomFeaturesPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <FloatingCTA />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
